import { somenteDigitos } from '@contefy/shared';

export function mascaraCpf(v: string): string {
  const d = somenteDigitos(v).slice(0, 11);
  return d
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
}

export function mascaraTelefone(v: string): string {
  const d = somenteDigitos(v).slice(0, 11);
  if (d.length <= 10) return d.replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2');
  return d.replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2');
}

export function mascaraCep(v: string): string {
  return somenteDigitos(v)
    .slice(0, 8)
    .replace(/(\d{5})(\d)/, '$1-$2');
}

/** Campo de dinheiro: o usuário digita dígitos e vê "R$ 1.234,56"; guardamos centavos. */
export function centavosParaTexto(centavos: number | null | undefined): string {
  if (centavos == null || Number.isNaN(centavos)) return '';
  return (centavos / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export function textoParaCentavos(v: string): number {
  const d = somenteDigitos(v);
  return d ? Number(d) : 0;
}

export function dataCurta(iso: string | null | undefined): string {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' });
}
